const faqs = [
  {
    q: '汗汗漫画需要付费吗？',
    a: '完全不需要！汗汗漫画网上的所有漫画都是免费阅读的，韩漫、日漫、国漫全部免费全集开放，无需注册登录即可畅读。',
  },
  {
    q: '什么是下拉式连续阅读？',
    a: '下拉式连续阅读是一种创新的漫画浏览方式，你只需向下滑动页面即可无缝阅读下一话内容，不用像传统翻页那样频繁点击。阅读体验更流畅、更沉浸。',
  },
  {
    q: '支持哪些漫画类型？',
    a: '汗汗漫画覆盖韩漫、日漫、国漫三大主流类型，细分为恋爱、热血、悬疑、奇幻、都市、校园、职场、冒险、搞笑等数十个分类，满足各类漫友需求。',
  },
  {
    q: '更新速度快吗？',
    a: '我们每日同步更新热门连载漫画，热门作品通常在官方更新后第一时间同步上线，追更不落后。',
  },
  {
    q: '手机上看漫画会卡吗？',
    a: '不会！汗汗漫画采用全球CDN加速和高清压缩技术，在手机上同样流畅加载，画质清晰不模糊。无论WiFi还是移动网络，都能畅快阅读。',
  },
  {
    q: '如何找到想看的漫画？',
    a: '你可以通过首页的「漫题索引」按类型浏览，或通过「人气排行」查看热门作品，也可以在「编辑精选」中发现高分佳作。分类清晰，找漫超方便。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于汗汗漫画的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, idx) => (
            <div
              key={idx}
              className="p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70"
            >
              <h3 className="font-heading text-base text-foreground-950 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0">Q{idx + 1}.</span>
                <span>{item.q}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}